import React from "react";
import { Container, Loader, Spacer } from "./ColdStartLoaderStyles";
import AnimatedMessage from "../../UI/AnimatedMessage/AnimatedMessage";

export default function ColdStartLoader() {
  return (
    <Container>
      <Loader>
        <span />
        <span />
        <span />
      </Loader>
      <Spacer />
      <h1>
        <AnimatedMessage>Detecting patterns</AnimatedMessage>
      </h1>
    </Container>
  );
}
